
export default {
    alphaKaz: {
        getMessage: field => 'Только русские и казахские символы',
        validate: value =>  /^[А-ЯЁӘҒҚҢӨҰҮҺІ \-]+$/i.test(value),
    },
    alphaKazNum: {
        getMessage: field => 'Только русские и казахские символы 2',
        validate: value =>  /^[А-ЯЁӘҒҚҢӨҰҮҺІ0-9 \-]+$/i.test(value),
    }
};